export default [
  {
    title: 'Sexual Assault Referral Centre (SARC)',
    description:
      'Provide immediate support and advice, including medical examinations and tests.',
    website: 'https://www.thesurvivorstrust.org/sarc',
    phone: 'Dial 111 to find the nearest centre',
  },
  {
    title: 'Rape Crisis',
    description:
      'Offer specialist support and services to women and girls who have experienced rape, sexual violence, or sexual abuse at any time.',
    website: 'https://www.rapecrisis.org.uk',
  },
  {
    title: 'Victim Support',
    description:
      'Free and confidential support 24/7 – regardless of whether you have reported the crime to the police.',
    website: 'https://www.victimsupport.org.uk',
    phone: '0808 168 9111',
  },
  {
    title: 'Galop (LGBT+)',
    description:
      'Advice, support and advocacy for people who have experienced hate crime, domestic abuse and sexual violence.',
    website: 'https://www.galop.org.uk',
    phone: '0207 704 2040',
  },
  {
    title: 'Survivors UK',
    description:
      'Individual counselling, group work and helpline services for survivors who identify as male, trans, non-binary, or have identified as male in the past, no matter when the abuse happened.',
    website: 'https://www.survivorsuk.org',
    phone: '0203 598 3898',
  },
  {
    title: 'Samaritans',
    description:
      'You can get in touch about anything that’s troubling you, no matter how large or small the issue feels.',
    website: 'https://www.samaritans.org/',
    phone: '0845 790 9090',
  },
  {
    title: "Musicians' Union",
    description:
      "You can directly contact the Musicians' Union for further support in confidence.",
    website: 'https://www.musiciansunion.org.uk/safespace',
    email: 'safespace@theMU.org',
  },
];
